export const cnjLawsuitNumberRegExp =
  /\b(\d{1,7})[.-]?(\d{2})[.-]?(\d{4})[.-]?(\d)[.-]?(\d{2})[.-]?(\d{4})\b/g
